// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { UpdateClaimsProcessorAttributeRequest } from './update-claims-processor-attribute-request';

/** See com.rev360.pms.api.controller.admin.practicepreferences.UpdateClaimProcessingPreferencesRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateClaimProcessingPreferencesRequest extends GandalfModelBase {

	@GandalfArray(UpdateClaimsProcessorAttributeRequest)
	claimsProcessorAttributes!: UpdateClaimsProcessorAttributeRequest[] | null;

	@GandalfProperty({ designType: Number })
	processorId!: number | null;

	@GandalfProperty({ designType: Boolean })
	useProcessorForStatements!: boolean | null;

}
